"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TealiumEventAction = exports.TealiumComponent = exports.TealiumElement = exports.TealiumFormat = exports.TealiumAction = exports.NOTIFICATION_ERROR_CLOSE = exports.NOTIFICATION_ERROR_OPEN = exports.NOTIFICATION_SUCCESS_CLOSE = exports.NOTIFICATION_SUCCESS_OPEN = exports.REQUEST_NOTIFICATION = void 0;
exports.REQUEST_NOTIFICATION = {
    OTP: 'REQUEST_NOTIFICATION_OTP',
    BIOMETRIC_TRUSTED_CONFIRMATION: 'REQUEST_NOTIFICATION_TRUSTED_CONFIRMATION',
    OTP_LOGIN: 'REQUEST_NOTIFICATION_OTP_LOGIN',
    BIOMETRIC_TRUSTED_CONFIRMATION_LOGIN: 'REQUEST_NOTIFICATION_TRUSTED_CONFIRMATION_LOGIN',
};
exports.NOTIFICATION_SUCCESS_OPEN = {
    OTP: 'NOTIFICATION_SUCCESS_OPEN_OTP',
    BIOMETRIC_TRUSTED_CONFIRMATION: 'NOTIFICATION_SUCCESS_OPEN_TRUSTED_CONFIRMATION',
    OTP_LOGIN: 'NOTIFICATION_SUCCESS_OPEN_OTP_LOGIN',
    BIOMETRIC_TRUSTED_CONFIRMATION_LOGIN: 'NOTIFICATION_SUCCESS_OPEN_TRUSTED_CONFIRMATION_LOGIN',
};
exports.NOTIFICATION_SUCCESS_CLOSE = {
    OTP_LOGIN: 'NOTIFICATION_SUCCESS_CLOSE_OTP_LOGIN',
    BIOMETRIC_TRUSTED_CONFIRMATION_LOGIN: 'NOTIFICATION_SUCCESS_CLOSE_TRUSTED_CONFIRMATION_LOGIN',
};
exports.NOTIFICATION_ERROR_OPEN = {
    OTP: 'NOTIFICATION_ERROR_OPEN_OTP',
    BIOMETRIC_TRUSTED_CONFIRMATION: 'NOTIFICATION_ERROR_OPEN_TRUSTED_CONFIRMATION',
    OTP_LOGIN: 'NOTIFICATION_ERROR_OPEN_OTP_LOGIN',
    BIOMETRIC_TRUSTED_CONFIRMATION_LOGIN: 'NOTIFICATION_ERROR_OPEN_TRUSTED_CONFIRMATION_LOGIN',
};
exports.NOTIFICATION_ERROR_CLOSE = {
    OTP_LOGIN: 'NOTIFICATION_ERROR_CLOSE_OTP_LOGIN',
    BIOMETRIC_TRUSTED_CONFIRMATION_LOGIN: 'NOTIFICATION_ERROR_CLOSE_TRUSTED_CONFIRMATION_LOGIN',
};
var TealiumAction;
(function (TealiumAction) {
    TealiumAction["CLOSE"] = "close";
    TealiumAction["OPEN"] = "open";
    TealiumAction["REQUEST"] = "request";
    TealiumAction["RETRY"] = "retry";
    TealiumAction["CLICK"] = "click";
})(TealiumAction || (exports.TealiumAction = TealiumAction = {}));
var TealiumFormat;
(function (TealiumFormat) {
    TealiumFormat["SNACKBAR"] = "snackbar";
    TealiumFormat["LINK"] = "link";
    TealiumFormat["CROSS"] = "cross";
})(TealiumFormat || (exports.TealiumFormat = TealiumFormat = {}));
var TealiumElement;
(function (TealiumElement) {
    TealiumElement["FULL"] = "full";
    TealiumElement["CROSS"] = "cross";
    TealiumElement["REQUEST"] = "requestNewCode";
    TealiumElement["RESEND"] = "newNotification";
    TealiumElement["RESEND_LOGIN"] = "sendNewNotification";
})(TealiumElement || (exports.TealiumElement = TealiumElement = {}));
var TealiumComponent;
(function (TealiumComponent) {
    TealiumComponent["SNACKBAR_ERROR"] = "snackbar/error/newNotification";
    TealiumComponent["SNACKBAR_SUCCESS"] = "snackbar/success/newNotification";
    TealiumComponent["TRUSTED_CHALLENGE_SNACKBAR_SUCCESS"] = "snackbar/success/notificationSent";
    TealiumComponent["TRUSTED_CHALLENGE_SNACKBAR_ERROR"] = "errorSnackbarSendingErrorNotification";
    TealiumComponent["OTP"] = "otp";
    TealiumComponent["TRUSTED_CHALLENGE"] = "trustedChallenge";
    TealiumComponent["OTP_LOGIN_CHALLENGE_SNACKBAR_SUCCESS"] = "snackbar/success/checkTextMessegesForCode";
    TealiumComponent["OTP_LOGIN_CHALLENGE_SNACKBAR_ERROR"] = "snackbar/error/unabledToSendCodeVerification";
})(TealiumComponent || (exports.TealiumComponent = TealiumComponent = {}));
var TealiumEventAction;
(function (TealiumEventAction) {
    TealiumEventAction["SNACKBAR_ERROR"] = "errorSnackbarNewNotification";
    TealiumEventAction["SNACKBAR_SUCCESS"] = "successSnackbarNewNotification";
    TealiumEventAction["TRUSTED_CHALLENGE_SNACKBAR_ERROR"] = "errorSnackbarSendingErrorNotification";
    TealiumEventAction["TRUSTED_CHALLENGE_SNACKBAR_SUCCESS"] = "successSnackbarNotificationSent";
    TealiumEventAction["OTP_LOGIN_CHALLENGE_SNACKBAR_SUCCESS"] = "successSnackbarCheckTextMessegesForCode";
    TealiumEventAction["OTP_LOGIN_CHALLENGE_SNACKBAR_ERROR"] = "errorSnackbarUnabledToSendCodeVerification";
    TealiumEventAction["CLICK_LINK"] = "clickLink";
})(TealiumEventAction || (exports.TealiumEventAction = TealiumEventAction = {}));
//# sourceMappingURL=actions.constants.js.map